<script>
	import AdultScore from './AdultSev.svelte';
	import PedScore from './PedSev.svelte';

	let sevScore = 0;

	function activetab() {
		let a = this.querySelector('input[type=radio]').value;
		let value = Math.abs(a);

		parent = Array.from(this.parentNode.children);
		parent.forEach(function (e,i) {
			e.classList.remove("active");
			if (e.classList.contains("last")) { 
				e.style["border-color"]= "black";
			} else {
				e.style["border-color"] = "rgba(172, 184, 184, 0.3)";
			}	
		});
	    this.classList.add("active");	
		this.style["border"] = "2px solid rgb(0,0,0)";
	
	
	};

</script>

<section>
	<div><h3>SEVERITY SCORE</h3></div>
	<div class="scoreSheet">	
		<div>
			<div class="vitals grid-two">
				<label on:click={activetab}><input type=radio bind:group={sevScore} value={1}}>Pediatric &le; 16</label>
				<label class="active" on:click={activetab}><input type=radio bind:group={sevScore} value={0}>Adult</label>
			</div>
		</div>

		{#if sevScore == 0}
		<AdultScore/>
		{:else}
		<PedScore/>
		{/if}

	</div>
</section>

<style>
	
	section {
		font-family: bebas-neue-by-fontfabric,sans-serif;
		font-weight: 700;
		font-style: normal;
		justify-content: center;
		align-items: center;
		color: rgba(0, 0, 0, 0.976);
		overflow: hidden;
		padding: 2rem 1rem 2rem 1rem;	

	}

	section h3 {
		font-size: 2rem;
		text-align: center;
	}

	p {
		text-align: left;
		font-size: 1rem;
		color:rgba(65, 64, 64, 1);
		margin: 0.4rem;
	}

	.scoreSheet {
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	}
	.vitals {
		margin: 13px;
		text-align: center;
	}

	label {
		font-family: expressway,sans-serif;
		font-weight: 400;
		font-style: normal;
		display: inline-block;
		text-align: center;
		font-size: 0.8rem;
		color: rgba(0, 0, 0, 0.3);
		border: 2px solid rgba(0, 0, 0, 0.3);
		border-radius: 0.2rem;
		padding: 0.08rem;
		background: transparent;
	}
	
	.active {
		border: 2px solid rgb(0,0,0);
		background-color:rgba(35, 175, 169, 0.07);
		color: rgb(0,0,0);
	}
	
	.grid-two {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}

	input[type="radio"] {
		display: none;
		}


</style>




